<template>
  <v-container
    fluid
    class="grey lighten-5 fill-height"
  >
    <v-layout align-top>
      <v-flex
        xs12
        sm12
        md12
        lg8
        ma-5
      >
        <v-card
          max-width="90%"
          class="mx-auto"
        >
          <v-list subheader>
            <v-subheader>Chatbots</v-subheader>

            <v-list-item
              @click="noop()"
              v-for="(item, ix) in chatbots"
              :key="ix"
            >
              <v-list-item-avatar>
                <v-img src="https://cdn.dribbble.com/users/722835/avatars/normal/2aa863d0913f94812e4c74867836e3af.jpg?1573346454" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.name" />
              </v-list-item-content>

              <v-list-item-action>        
                <v-list-item-icon>
                  <v-icon
                    @click="noop()"
                    :color="item.link ? 'deep-blue accent-4' : 'grey'"
                  >
                    delete
                  </v-icon>
                </v-list-item-icon>
              </v-list-item-action>        
              <v-list-item-action>        
                <v-list-item-icon>
                  <v-icon
                    @click="noop()"
                    :color="item.link ? 'deep-blue accent-4' : 'grey'"
                  >
                    mdi-wrench
                  </v-icon>
                </v-list-item-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  name: 'Chatbots',
  components: {
  },
  computed: {
  },    
  data: () => ({
    chatbots: [
      {name: 'cbot-1701', link: 'https://telegram.com/cbot-1701'},
      {name: 'telegram-groupA', link: 'https://telegram.com/cbot-1701'},
      {name: 'whatsapp-groupA', link: 'https://telegram.com/cbot-1701'},
      {name: 'slack-groupA', link: 'https://telegram.com/cbot-1701'},
      {name: 'messenger-groupB', link: 'https://telegram.com/cbot-1701'},
    ]
  }),
  methods : {
    noop: () => {
      return;
    }
  }
};
</script>


<style scoped>
</style>
